import axios from 'axios'
import {
  getToken,
  markAuthRedirectError,
  redirectToLogin
} from '../utils/auth'

const AUTH_EXPIRED_HINTS = [
  '\u4f1a\u8bdd',
  '\u672a\u767b\u5f55',
  '\u8fc7\u671f',
  '\u91cd\u65b0\u767b\u5f55',
  '\u767b\u5f55\u72b6\u6001\u65e0\u6548'
]

const request = axios.create({
  // baseURL: 'http://172.23.112.1:8080/api',
  baseURL: '/api',
  timeout: 15000
})

function isAuthExpiredMessage(message) {
  const text = String(message || '')
  return AUTH_EXPIRED_HINTS.some((hint) => text.includes(hint))
}

function normalizeError(message, error) {
  const target = error instanceof Error ? error : new Error(message || '\u8bf7\u6c42\u5931\u8d25')
  if (message) {
    target.message = message
  }
  return target
}

function rejectAuthRedirect(message, error) {
  const authError = markAuthRedirectError(normalizeError(
    message || '\u4f1a\u8bdd\u5df2\u8fc7\u671f\uff0c\u8bf7\u91cd\u65b0\u767b\u5f55',
    error
  ))
  redirectToLogin()
  return Promise.reject(authError)
}

request.interceptors.request.use((config) => {
  const token = getToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

request.interceptors.response.use(
  (response) => {
    const body = response.data || {}
    if (body.code === 0) {
      return body.data
    }
    if (isAuthExpiredMessage(body.message)) {
      return rejectAuthRedirect(body.message)
    }
    return Promise.reject(normalizeError(body.message || '\u8bf7\u6c42\u5931\u8d25'))
  },
  (error) => {
    const response = error && error.response ? error.response : null
    const status = response ? response.status : 0
    const body = response && response.data ? response.data : {}
    const message = body && body.message ? body.message : error.message

    if (status === 401 || status === 403 || isAuthExpiredMessage(message)) {
      return rejectAuthRedirect(message, error)
    }

    return Promise.reject(normalizeError(message || '\u8bf7\u6c42\u5931\u8d25', error))
  }
)

export default request
